<template>
    <div class="tab-pane" :class="{'tab-nofooter-pane' : !((((activeName == 1)||(activeName == 3))&& activeName == dataSource.status && accessPoint[isShow[activeName - 1]])|| (activeName == dataSource.status&& accessPoint[isShow[activeName - 1]]&& accessPoint['outuser']&& !accessPoint['mineuser']))}">
    <!-- <div class="tab-pane tab-nofooter-pane" > -->
        <div class="tab-box clearfix" :class="isCollapse ? 'openFlow' : 'hideFlow'">
            <!-- 右边 工作流记录 展开或折叠 -->
            <div class="sfold" :class="isCollapse ? 'openFold' : 'closeFold'" @click="isCollapse = !isCollapse">
                <svg-icon icon-class="s-fold"/>
            </div>
        
            <!-- 左边 -->
            <template v-if='!mainLoading' >
                <!-- 审核信息 -->
                <check-info ref="info" v-if="activeName == 1" class="left-box" :dataSource='dataSource' :flowList='flowList.filter((item)=>{return item.status === -1})'></check-info>

                <!-- 上传完稿文件(乙方) -->
                <upload-file ref="upload" v-if="activeName == 2" class="left-box" :dataSource='dataSource' ></upload-file>

                <!-- 验收完稿文件 -->
                <accept-file ref="accept" v-if="activeName == 3" class="left-box" :dataSource='dataSource' :flowList='flowList.filter((item)=>{return item.status === -4})'></accept-file>

                <!-- 结算/验收(乙方) -->
                <settle ref="settle" v-if="activeName == 4" class="left-box" :dataSource='dataSource'></settle>
            </template>
             <div
                v-loading='mainLoading' style="width: 784px;min-height:100%" v-if="mainLoading"
                ></div>

            <!-- 右边 -->
            <div class="right-box" v-if="isCollapse">
                <!-- 标题 -->
                <div class="title-box">
                    <h2 class="title">工作流记录</h2>
                </div>

                <!-- 时间线 :class="item.status == 3 ? 'unLine' : ''"-->
                <div class="timeline-box" v-loading="logLoading" style="height:70%">
                    <div class="timeline-item" v-for="(item,index) in flowList" :key="index" >
                        <!-- 拒绝图标 -->
                        <svg-icon class="icon" icon-class="error-circle-icon" v-if="item.status === -1"  style="margin-left: 1px;"/>
                        <!-- 最后已完成图标 -->
                        <i class="icon el-icon-circle-check" v-else-if="item.status === 5"></i>
                        <!-- 当前节点图标 -->
                        <i class="icon current-icon" v-else-if="index === flowList.length-1"></i>
                        <!-- 已经经过的图标 -->
                        <i class="icon el-icon-circle-check" v-else></i>
                        <div class="item-content">
                            <div class="logTime" v-if="item.logTime">{{item.logTime}}</div>
                            <div class="content">
                                <span class="user">{{item.userName}}</span>
                                <span class="desc" v-html="item.message"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       

        <!-- 底部固定按钮 甲方-->
        <div class="footer-box" v-if="((activeName == 1)||(activeName == 3))&& activeName == dataSource.status && accessPoint[isShow[activeName - 1]]" >
            <!-- 审核信息 -->
            <template v-if="activeName == 1 && accessPoint[isShow[0]]">
                 <div class="check-box" >
                    <label>通知方式：</label>
                    <el-checkbox v-model="checkedEmail">邮箱</el-checkbox>
                </div>
                <el-button type="primary" plain @click="refuseVisible = true">拒绝</el-button>
                <el-button type="primary" @click="handleFun(2,'')">审核通过</el-button>
            </template>
           
            <!-- 验收完稿文件 -->
            <template v-if="activeName == 3  && accessPoint[isShow[2]]">
                <el-button type="primary" plain @click="handleUpdate('update')">修改</el-button>
                <el-button type="primary" @click="handleUpdate('sure')">确定</el-button>
            </template>
        </div>
         <!-- 底部固定按钮 乙方-->
        <div class="footer-box" v-if="activeName == dataSource.status&& accessPoint[isShow[activeName - 1]]&& accessPoint['outuser']&& !accessPoint['mineuser']" >
            <!-- 上传完稿文件 乙方 -->
            <template v-if="activeName == 2 && accessPoint[isShow[1]]">
                 <div class="check-box" >
                    <label>通知方式：</label>
                    <el-checkbox v-model="checkedEmail">邮箱</el-checkbox>
                </div>
                <el-button type="primary" plain @click="sureUploadFun(0)">保存</el-button>
                <el-button type="primary" @click="sureUploadFun(1)">确认</el-button>
            </template>

             <!-- 结算验收文件 -->
            <template v-if="activeName == 4  && accessPoint[isShow[3]]">
                <div class="check-box" >
                    <label>通知方式：</label>
                    <el-checkbox v-model="checkedEmail">邮箱</el-checkbox>
                </div>
                <el-button type="primary" @click="handleSave">确定</el-button>
            </template>
        </div>

        <!-- 拒绝弹框意见 width="400px"-->
        <el-dialog title="拒绝理由" :visible.sync="refuseVisible"  :append-to-body="true" class="refuseDialog">
            <el-form ref="ruleForm" :model="refuseForm" :rules="rulesForm">
            <el-form-item  prop="refuseContent">
                <el-input v-model="refuseForm.refuseContent" :rows='5' type='textarea'></el-input>
            </el-form-item>
            </el-form>
              <span slot="footer" >
                <el-button style="margin-left:50px;" type="primary" @click="refuseFun()">确定</el-button>
                <el-button @click="refuseVisible = false">取消</el-button>
            </span>
        </el-dialog>
    
    </div>
</template>

<script>
import UploadFile from './uploadFile'
import CheckInfo from './checkInfo.vue'
import AcceptFile from './acceptFile'
import Settle from './settle'
import {flowStatusArr} from './flowLogDict'
import {outsource_flowDetail,outsource_flowLogList,outsource_flowModifyStatus} from "@File~/api/outsourcing";

export default {
    components: { CheckInfo, UploadFile, AcceptFile, Settle},
    inject:['reload'],
    props:{
        activeName:{
            type: String | Number,
        },
        rowId:{
            type:Number
        }
        // dataSource:{
        //     type:Object,
        //     default:()=>{
        //         return null
        //     }
        // }
    },
    data() {
        return {
            dataSource:{},
            logLoading:false,
            mainLoading:false,
            refuseVisible:false,//拒绝弹框标识
            refuseForm:{refuseContent:''},//拒绝理由
            rulesForm:{
                refuseContent: [{ required: true, message: '请输入拒绝理由', trigger: 'required' }]
            },
            isCollapse: true, //工作流日志标识
            checkedEmail: false, // 邮箱
            flowList:[],
            //获取权限点
            accessPoint: this.$store.getters.accessPoint, //权限点
            isShow:['audit:dutygive','uploadfile:upload','checkfile:checkfile','overfile:upload'],

        }
    },
    created(){
        this.mainLoading = true
        outsource_flowDetail(this.rowId).then((response) => {
            if (response.code == 1) {
                this.dataSource = response.data;
                this.mainLoading = false;
            }
        });
        this.getFlowLog();

    },

    methods: {
        getFlowLog(){
            let that = this
            that.logLoading = true;
            outsource_flowLogList(this.rowId).then((response) => {
                if (response.code == 1) {
                    that.flowList = response.data
                    that.flowList.map((item)=>{
                        for(let index = 0; index<flowStatusArr.length; index ++){
                            if(item.status === flowStatusArr[index].status){
                                item.message = flowStatusArr[index].message;
                            }
                            continue;
                        }
                    })
                    that.logLoading = false

                }
            });
        },


        // 修改工单状态接口
        handleFun(status,msg) {
            let data = {
                id:this.dataSource.id,
                userId:this.$store.state.user.userId,
                status:status,
                statusStr:msg,
                // comment:'',
                noticeType:this.checkedEmail?1:0,
            }
            outsource_flowModifyStatus(data).then(response => {
                if(response.code == 1) {
                    this.$message({type:'success',message:'操作成功'})
                    // this.$router.replace({path: '/outsourceTaskCenter/outsourceTaskCenter'}) 
                    this.reload()
                }
            })
        },

        //拒绝确认方法
        refuseFun(){
            this.$refs.ruleForm.validate((valid) => {
                if(valid) {
                    // this.handleFun(-1,'拒绝了该审批<br/>拒绝理由：'+this.refuseForm.refuseContent)
                    this.handleFun(-1,this.refuseForm.refuseContent)
                }
            })
        },
        // 取消
        handleCancel() {

        },
         //打开修改弹框
        handleUpdate(flag){
            //flag:update/sure
            this.$refs.accept.openDialog(flag);
        },

        
        // 结算/验收（乙方）
        handleSave() {
            this.$refs.settle.sureFun(this.checkedEmail?1:0);
        },
       
        //完稿文件确认上传 保存为0，确认为1
        sureUploadFun(item){
            this.$refs.upload.sureUploadFun(this.checkedEmail?1:0,item)
        }
    }
}
</script>

<style lang="scss" scoped>
    .tab-pane{
        padding: 16px 22px 16px 32px;
        height: calc(100vh - 110px - 68px);
        overflow: scroll;
        position: relative;
    }
    .tab-nofooter-pane{
        height: calc(100vh - 110px);
    }
    .tab-box{
        min-height: 100%;
        width: 100%;
        position: relative;
        display: flex;
        flex-flow: row nowrap;

        .sfold{
            position: absolute;
            top: 2px;
            right: 2px;
            cursor: pointer;

            padding: 8px;
            background: #FFFFFF;
            border-radius: 4px;

            transition: right .28s;
        }
        .closeFold{
            transform: rotate(180deg);
        }
    }

    .right-box{
        // position: fixed;
        // top: 126px;
        // right: 32px;
        // z-index: 1009;
        width: 220px;
        height: 450px;
        background: #FFFFFF;
        border-radius: 4px;
        margin-left: 16px;
        transition: opacity .28s;
        
    }

    .left-box{
        transition: width .28s;
        padding: 26px 24px;
        background: #FFFFFF;
        border-radius: 4px;
    }

    .openFlow{
        .right-box{
            opacity: 1;
            overflow: scroll;
        }
        .left-box{
            width: 784px;
        }
    }

    .hideFlow{
        .sfold{
            right: -18px;
            
        }
        .right-box{
            opacity: 0;
        }
        .left-box{
            width: 988px;
        }
    }

    .right-box{
        padding:12px 16px 10px;
        .title-box{
            margin: 14px 0 22px;
            padding-left: 12px;
            position: relative;
            &::before{
                content: '';
                position:absolute;
                top: 2px;
                left: 0;
                width: 4px;
                height: 18px;
                background: #3A89FF;
            }
            .title{
                margin: 0;
                font-size: 16px;
                font-weight: 400;
                color: #333333;
                line-height: 22px;
            }
        }
        .timeline-item{
            height: 77px;
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-start;
            align-items: flex-start;
            position: relative;
            &::before{
                content: '';
                position: absolute;
                top: 20px;
                left: 8px;
                width: 1px;
                height: 61px;
                border: 1px solid #E5E5E5;
            }
            .icon{
                flex-shrink: 0;
                margin-top: 3px;
                margin-right: 12px;
                width: 16px;
                height: 16px;
                font-size: 18px;
                color: #3A89FF;
            }
            .current-icon{
                background: #3a89ff33;
                border-radius: 100%;
                position: relative;
                &::after{
                    content: '';
                    position:absolute;
                    top: 4px;
                    left: 4px;
                    width: 8px;
                    height: 8px;
                    background: #3A89FF;
                    opacity: 0.8;
                    border-radius: 100%;
                }
            }
            .custom-icon{
                background: #FFFFFF;
                border: 1px solid #E5E5E5;
                border-radius: 100%;
            }
            .item-content{
                font-size: 14px;
                line-height: 20px;
            }
            .logTime{
                color: #666666;
            }
            .content{
                color: #333333;
            }
            .user{
                color: #3A89FF;
            }
            span{
                margin-right: 6px;
            }
        }
        .timeline-item:last-child::before{
            display:none;
        }
        .unLine{
            .content,.user{
                color: #999999;
            }
        }
    }
    
    .footer-box{
        position: fixed;
        right:0;
        bottom: 0;
        width: 1080px;
        height: 68px;
        background: #FFFFFF;
        box-shadow: 0px 4px 10px 4px rgba(0, 0, 0, 0.05), 0px -3px 5px 0px rgba(0, 0, 0, 0.08), 0px -1px 2px -2px rgba(0, 0, 0, 0.1);

        padding: 0 24px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-end;
        align-items: center;

        .check-box{
            margin-right: 64px;
            label{
                margin-right: 6px;
                font-size: 14px;
               color: #666666; 
            }
        }
        .el-button--primary.is-plain{
            color: #3A89FF;
            border: 1px solid #3A89FF;
            background: #FFFFFF;
        }
        .el-button{
            padding: 10px 15px;
        }
        .el-button+.el-button{
            margin-left: 12px;
        }
    }

    // 内容
    .left-box{
        ::v-deep.title-box{
            margin: 0px 0 22px;
            padding-left: 12px;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            position: relative;
            &::before{
                content: '';
                position:absolute;
                top: 2px;
                left: 0;
                width: 4px;
                height: 18px;
                background: #3A89FF;
            }
            .title{
                margin: 0;
                font-size: 16px;
                font-weight: 400;
                color: #333333;
                line-height: 22px;
            }

            .icon{
                font-size: 14px;
                margin-left: 8px;
                cursor: pointer;
            }
        }

        ::v-deep.model-box{
            display: flex;
            flex-flow: row wrap;
            justify-content: space-between;

            .item-box{
                width: 48%;
                display: flex;
                flex-flow: row nowrap;
                justify-self: flex-start;
                align-items: flex-start;
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 12px;
            }
            .all{
                width: 100%;
            }
            .label{
                display: block;
                margin-right:12px;
                min-width: 112px;
                text-align: right;
                color: #666666;
            }
            .value{
                font-size: 14px;
                line-height: 20px;
                color: #333333;
                p{
                    margin: 0;
                }
            }

            .value-box{
                display: flex;
                flex-flow: row nowrap;
                justify-self: flex-start;
                align-items: center;
                font-size: 14px;
                margin-bottom: 12px;
                .icon{
                    flex-shrink: 0;
                    width: 24px;
                    height: 24px;
                    margin-right: 4px;
                }
                .title{
                    color: #333333;
                }
                .size{
                    color: #999999;
                }
                .download{
                    color: #3A89FF;
                    margin-left: 8px;
                }
            }
        }

        ::v-deep .line{
            margin: 20px 0 30px;
            width:100%;
            height: 1px;
            border: 1px solid #EEEEEE;
        }
    }

    .refuseDialog{
        ::v-deep.el-dialog__body{
            padding-bottom: 0;
        }
    }
    

    
</style>